module.exports = __webpack_public_path__ + "static/media/chodba-prizemi-zadni-cela2.11fca250.jpg";